import api from '.';

export interface PlugAndPlayUser {
  id: number;
  firstName: string;
  lastName: string;
  roles?: { id: number; name: string }[];
}

interface GetUsersResponse {
  data: PlugAndPlayUser[];
}

export async function getUsers(): Promise<GetUsersResponse> {
  const { data } = await api.get('/users');
  return data;
}

export async function getUser(id: number): Promise<PlugAndPlayUser> {
  const { data } = await api.get(`/users/${id}`);
  return data;
}
